import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createCheckoutSession } from '../services/api';
import { Layout } from '../components/Layout';

export default function Upgrade() {
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    createCheckoutSession()
      .then((url) => {
        window.open(url, '_blank', 'noopener,noreferrer');
      })
      .catch((err) => {
        console.error('Checkout error:', err);
        setError('Unable to start checkout. Please try again.');
      });
  }, []);

  return (
    <Layout>
      <div style={{ textAlign: 'center', paddingTop: '80px' }}>
        {error ? (
          <div>
            <p style={{ color: 'var(--error-text)' }}>{error}</p>
            <button
              onClick={() => window.history.back()}
              style={{
                marginTop: '16px',
                color: 'var(--accent-blue)',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: '14px',
              }}
            >
              ← Go back
            </button>
          </div>
        ) : (
          <div>
            <p style={{
              color: 'var(--text-primary)',
              fontSize: '16px',
              fontWeight: 600,
              fontFamily: "'Outfit', sans-serif",
              marginBottom: '8px',
            }}>
              Checkout opened in a new tab
            </p>
            <p style={{
              color: 'var(--text-secondary)',
              fontSize: '14px',
              lineHeight: 1.5,
            }}>
              Complete your purchase there to activate Pro.
            </p>
            <button
              onClick={() => navigate('/editor')}
              style={{
                marginTop: '20px',
                color: 'var(--accent)',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: '14px',
              }}
            >
              ← Back to editor
            </button>
          </div>
        )}
      </div>
    </Layout>
  );
}
